import React, { ReactElement } from 'react';
import Block from '../../Layout/Block';
import '../home.scss';

const NeubauprojekteInfo = (): ReactElement => (
  <div style={{ paddingBottom: '2rem' }}>
    <h1>Neubauprojekte in Wien</h1>
    <div className="spacer" />
    <div className="p-grid">
      <div className="lg:col-6">
        <h2>Aktuelle Neubauprojekte in Wien</h2>
        <h3>Eigentumswohnungen und Mietwohnungen mit Erstbezug</h3>
        <Block>
          Auf dieser Plattform finden Sie aktuelle Neubauprojekte in Wien. Unter
          Neubauprojekte verstehen wir Projekte, bei denen Wohnungen von Grund
          auf neu errichtet (Neubauprojekte) oder von Grund auf saniert werden
          (generalsanierter Altbau). Wir präsentieren daher nur Wohnungen mit
          Erstbezug. Egal ob Sie in Wien eine Neubauwohnung, eine sanierte
          Altbauwohnung oder eine neu ausgebaute Dachgeschosswohnung suchen,
          hier sollten Sie fündig werden. Falls Sie auf der Suche nach einem
          Doppelhaus oder einem Reihenhaus sind, sollten Sie ebenfalls fündig
          werden.
        </Block>
        <h3>Aufbereitung der Neubauprojekte</h3>
        <Block>
          Alle Informationen über Neubauprojekte beziehen wir direkt vom
          jeweiligen Bauträger oder Makler. Wir fassen die Informationen der
          Neubauprojekte für Sie prägnant zusammen. So können Sie die
          wichtigsten Fakten schnell erfassen. Zusätzlich werten wir die
          öffentliche Verkehrsanbindung von jedem Neubauprojekt aus. Sie können
          dadurch Neubauprojekte in Wien filtern, die sehr gut an öffentliche
          Verkehrsmittel angebunden sind. Bei jedem Neubauprojekt können Sie
          eine Anfrage an den jeweiligen Bauträger, Makler oder Genossenschaft
          senden. Das zuständige Unternehmen wird mit Ihnen umgehend Kontakt
          aufnehmen und Ihnen die gewünschten Informationen zu Verfügung
          stellen.
        </Block>
      </div>
      <div className="lg:col-6">
        <h2>Wir geben einen Marktüberblick in Wien</h2>
        <h3>Neubauprojekte in Planung</h3>
        <Block>
          Anders als bei vielen anderen Plattformen finden Sie bei uns auch in
          Planung befindliche Neubauprojekte. Dadurch können Sie sich schon
          frühzeitig über Neubauprojekte informieren und sich bei Wunsch direkt
          beim Bauträger oder bei der Genossenschaft über das beigefügte
          Kontaktformular vormerken lassen. Wenn das Unternehmen den Verkauf
          startet, werden Sie umgehend kontaktiert.
        </Block>
        <h3>Neubauprojekte in der Bauphase</h3>
        <Block>
          Neben Projekten in Planung finden Sie auch Neubauprojekte, die sich
          gerade in Wien in Bau befinden. Kurz nach Baubeginn startet in der
          Regel der Verkauf bzw. die Vermietung der Wohnungen. Wir informieren
          Sie mit dem voraussichtlichen Fertigstellungsdatum und wesentlichen
          Updates.
        </Block>
        <h3>Fertiggestellte Neubauprojekte</h3>
        <Block>
          Natürlich finden Sie bei uns auch fertiggestellte Neubauprojekte. Hier
          sind in der Regel nur noch wenige Wohnungen verfügbar. Sollten bei
          einem Neubauprojekt keine Wohnungen mehr verfügbar sein, wird das
          Projekt von der Plattform genommen.
        </Block>
      </div>
    </div>
  </div>
);

export default NeubauprojekteInfo;
